module.exports = __webpack_public_path__ + "public/Icons/adminDeliveryIcon.png?3a20388f";